export default "__VITE_ASSET__6518b888__"